export default [
  {
    header: 'sidebar.reports',
    permission: ['admin', 'pto', 'supervisor', 'financier']

  },
  {
    title: 'sidebar.reports_pto',
    icon: 'ClipboardIcon',
    route: 'report',
    permission: ['admin', 'pto', 'supervisor', 'financier']
  },
  {
    title: 'sidebar.work_report',
    icon: 'ClipboardIcon',
    route: 'work-report',
    permission: ['admin', 'pto', 'supervisor', 'financier']
  },
  {
    title: 'sidebar.work_view_report',
    icon: 'ClipboardIcon',
    route: 'work-view-report',
    permission: ['admin', 'pto', 'supervisor', 'financier']
  },
  {
    title: 'sidebar.good_report',
    icon: 'ClipboardIcon',
    route: 'good-report',
    permission: ['admin', 'pto', 'supervisor', 'financier']
  },
]
